import { TReduxActions } from '../../types/redux';
import { EAddFavoriteActionTypes, EDeleteFavoriteActionTypes } from '../../actions/favorite';
import { IOffers } from '../../types/redux/offers';

export function offersReducer(offers: IOffers = {}, action: TReduxActions) {
  switch (action.type) {
    case EAddFavoriteActionTypes.Success: {
      const { offerId } = action.payload;

      return {
        ...offers,
        [offerId]: {
          ...offers[offerId],
          isFavorite: true,
        },
      };
    }

    case EDeleteFavoriteActionTypes.Success: {
      const { offerId } = action.payload;

      return {
        ...offers,
        [offerId]: {
          ...offers[offerId],
          isFavorite: false,
        },
      };
    }

    default:
      return offers;
  }
}
